import { apiClient } from "./client";

export const taskStatusAPI = {
  getTaskStatus(task_id) {
    return apiClient.get(`/task_status/${task_id}`);
  },
};

const sleep = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));

export const getTaskData = async (method) => {
  const res = await method();
  const taskID = res.data?.task_id;

  if (!taskID) return null;

  while (true) {
    const task_res = await taskStatusAPI.getTaskStatus(taskID);
    const status = task_res?.data?.status;

    if (status === "SUCCESS" || status === "FAILURE" || status === "ERROR") {
      return task_res.data;
    }

    await sleep(500);
  }
};
